import { MenuOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Image, Popover, Row } from 'antd';
import { Header } from 'antd/es/layout/layout';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllData } from '../../../../Utils/Storage';
import { useSelector } from 'react-redux';

function Headers({ showMenuButton = false, onMenuClick }) {
    const navigate = useNavigate();

    const s = useSelector((state) => state.user.user);
    const user = JSON.parse(s);

    const text = <Button type="link" onClick={() => profile()}><span>Profile</span></Button>;
    const content = (
        <div>
            <Button type="link" danger onClick={() => logout()}>
                Log Out
            </Button>
        </div>
    );

    const logout = () => {
        clearAllData();
        navigate('/login');
    };

    const profile = () => {
        navigate('/profile');
    };

    const full_name = user !== null && user !== undefined
        ? user.detail_user.first_name + ' ' + user.detail_user.last_name
        : '';

    return (
        <Header className="header app-header" style={{ backgroundColor: '#d6006e' }}>
            <Row align="middle" wrap={false}>
                <Col flex="auto" className="app-header-brand">
                    {showMenuButton && (
                        <Button
                            type="text"
                            aria-label="Buka menu"
                            icon={<MenuOutlined />}
                            onClick={onMenuClick}
                            className="app-header-menu-button"
                        />
                    )}
                    <Image
                        preview={false}
                        width={40}
                        src="https://images.tokopedia.net/img/cache/215-square/shops-1/2020/3/13/8008242/8008242_3c4a241b-6bc7-41bc-9522-7f37722862a8.jpeg"
                    />
                    <div className="app-brand-copy">
                        <strong>BOLDE POS</strong>
                        <span>Management System</span>
                    </div>
                </Col>
                <Col flex="none" className="app-header-user">
                    <Button
                        type="link"
                        className="app-header-user-name"
                        onClick={() => profile()}
                    >
                        {full_name}
                    </Button>
                    <Popover placement="bottomRight" title={text} content={content} trigger="click">
                        {user !== null && user !== undefined && user.detail_user?.image ? (
                            <img
                                src={user.detail_user.image}
                                alt={full_name || 'User'}
                                style={{ width: 32, height: 32, borderRadius: 20, objectFit: 'cover', cursor: 'pointer' }}
                            />
                        ) : (
                            <Avatar icon={<UserOutlined />} />
                        )}
                    </Popover>
                </Col>
            </Row>
        </Header>
    );
}

export default Headers;
